import { render, staticRenderFns } from "./Destination.ts.vue?vue&type=template&id=e2b31b8a"
import script from "./Destination.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./Destination.ts.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports